import { render, staticRenderFns } from "./OperationAddTab.vue?vue&type=template&id=8d18e9e6"
import script from "./OperationAddTab.vue?vue&type=script&lang=js"
export * from "./OperationAddTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports